// src/components/landing/PartnerStrip.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const PARTNERS = [
  'Bharat Sevak Samaj',
  'Planning Commission, Govt. of India',
  'Govt. of Kerala Approved',
];

export default function PartnerStrip() {
  return (
    <Box sx={{
      bgcolor: '#1e293b', py: 4, px: { xs: 3, md: 8 },
      borderTop: '1px solid rgba(255,255,255,0.06)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      <Typography sx={{ textAlign: 'center', fontSize: '0.68rem', letterSpacing: 3, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', mb: 3 }}>
        Accredited & Recognized By
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: { xs: 2, md: 5 }, flexWrap: 'wrap' }}>
        {PARTNERS.map((p) => (
          <Box key={p} sx={{
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 2.5, px: 2.5, py: 1.25, bgcolor: 'rgba(255,255,255,0.06)',
          }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: 0.5, whiteSpace: 'nowrap' }}>
              {p}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
